import { useSelector } from 'react-redux';
import { useGetCurrentPhdStudentProfileQuery } from '../../../../redux/services/phd';

const usePhdStudentProfile = ({ enabled = true } = {}) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const hasStudentPlanPermission = useSelector((state) =>
    Boolean(state.auth.user?.permissions?.['phd-student-plan.index']),
  );
  const skip = !isLoggedIn || !enabled || !hasStudentPlanPermission;
  const query = useGetCurrentPhdStudentProfileQuery(undefined, {
    skip,
  });

  return {
    isLoggedIn,
    ...query,
  };
};

export default usePhdStudentProfile;

export const mapStudentProfileToFormDefaults = (studentProfile) => {
  if (!studentProfile) {
    return {};
  }

  const resolveSupervisorDisplayName = (thesis) => {
    if (!thesis) {
      return undefined;
    }

    return (
      thesis?.supervisor_display_name ||
      thesis?.supervisor?.full_name ||
      thesis?.supervisor?.display_name ||
      thesis?.supervisor?.person?.full_name ||
      thesis?.supervisor?.person?.name ||
      thesis?.supervisor?.name ||
      undefined
    );
  };

  const theses = [...(studentProfile.theses || [])];
  const latestThesis = theses.sort(
    (a, b) =>
      new Date(b?.updated_at || b?.created_at || 0).valueOf() -
      new Date(a?.updated_at || a?.created_at || 0).valueOf(),
  )[0];
  const thesisWithSupervisor = theses
    .sort(
      (a, b) =>
        new Date(b?.updated_at || b?.created_at || 0).valueOf() -
        new Date(a?.updated_at || a?.created_at || 0).valueOf(),
    )
    .find((thesis) => Boolean(resolveSupervisorDisplayName(thesis)));
  const preferredThesis = thesisWithSupervisor || latestThesis;

  const supervisorDisplayName = resolveSupervisorDisplayName(preferredThesis);

  const primaryAddress = [...(studentProfile.addresses || [])].sort(
    (left, right) => Number(left.id) - Number(right.id),
  )[0];
  const studentFullAddress = primaryAddress
    ? [
        primaryAddress.street,
        primaryAddress.house_number,
        primaryAddress.postal_code,
        primaryAddress.city,
        primaryAddress.country,
      ]
        .filter(Boolean)
        .join(', ')
    : undefined;

  const studyField =
    studentProfile.study_field ||
    studentProfile.studyField ||
    preferredThesis?.study_field;
  const studyProgramName = studyField?.study_field || undefined;
  const studyFieldName =
    studyField?.focus || studyField?.study_field || undefined;

  return {
    phd_student_id: studentProfile.id,
    student_display_name: studentProfile.person?.full_name,
    supervisor_display_name: supervisorDisplayName,
    student_study_form: studentProfile.study_form,
    student_study_program: studyProgramName,
    student_study_program_name: studyProgramName,
    student_study_field: studyFieldName,
    student_full_address: studentFullAddress,
    thesis_title_sk:
      preferredThesis?.title_sk ?? preferredThesis?.title ?? undefined,
    thesis_title:
      preferredThesis?.title_sk ?? preferredThesis?.title ?? undefined,
    thesis_title_en:
      preferredThesis?.title_en ?? preferredThesis?.title_english ?? undefined,
  };
};
